__webpack_require__.p = "/energy/paper/Energy_Seaweeds/";